import { useMemo } from "react"

import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"

import type { Entity } from "types/entity"
import { EntityAbilitySlot } from "types/entity"

import { ItemPageBlockWrapper } from "../item-page-block-wrapper"
import { AbilitiesItem } from "./abilities-item"

export const abilitiesOrder = [
  EntityAbilitySlot.BASIC,
  EntityAbilitySlot.SPECIAL,
  EntityAbilitySlot.ULTIMATE,
  EntityAbilitySlot.ASSIST_AND_COUNTER,
]

type AbilitiesProps = {
  entity?: Entity
  isShip: boolean
}

export function Abilities({ entity, isShip }: AbilitiesProps) {
  const { isMobile } = useTailwindBreakpoints()
  const sortedAbilities = useMemo(() => {
    return (entity?.abilities || [])
      .filter(a => a.slot !== EntityAbilitySlot.ASSIST_AND_COUNTER)
      .sort((a, b) => abilitiesOrder.indexOf(a.slot) - abilitiesOrder.indexOf(b.slot))
  }, [entity?.abilities])

  const damage = entity?.damage || 0
  const power = entity?.power || 1

  return isMobile ? (
    <Box>
      {sortedAbilities.map(({ ability, level, unlocked, slot }, i) => (
        <AbilitiesItem
          key={i}
          ability={ability}
          level={level}
          unlocked={unlocked}
          slot={slot}
          power={power}
          className={i !== sortedAbilities.length - 1 ? "mb-6" : ""}
          damage={damage}
          isShip={isShip}
        />
      ))}
    </Box>
  ) : (
    <Box>
      <ItemPageBlockWrapper title="Abilities">
        {sortedAbilities.map(({ ability, level, unlocked, slot }, i) => (
          <AbilitiesItem
            key={i}
            ability={ability}
            level={level}
            unlocked={unlocked}
            power={power}
            slot={slot}
            className={i !== sortedAbilities.length - 1 ? "mb-6" : ""}
            damage={damage}
            isShip={isShip}
          />
        ))}
      </ItemPageBlockWrapper>
    </Box>
  )
}
